import { jwtDecode } from 'jwt-decode'

import type { JWTPayload } from '@/utils/auth'
import {
  getAuthToken,
  getRefreshToken,
  getSessionTokenPayload
} from '@/utils/auth'

export const USER_ROLE_CLUB = 'USER_ROLE_CLUB'

export function tokenHasClubRole(token?: string | null): boolean {
  if (!token) {
    return false
  }
  try {
    const payload = jwtDecode<JWTPayload>(token)
    return (payload.roles ?? []).includes(USER_ROLE_CLUB)
  } catch {
    return false
  }
}

export function isClubUserSession(): boolean {
  return (
    tokenHasClubRole(getAuthToken()) ||
    tokenHasClubRole(getRefreshToken()) ||
    (getSessionTokenPayload()?.roles ?? []).includes(USER_ROLE_CLUB)
  )
}

export function canParticipateInFanTasks(isAuthenticated: boolean): boolean {
  if (!isAuthenticated) {
    return false
  }
  return !isClubUserSession()
}

export type TasksAccessHintKey = 'signInForTasksHint' | 'fanOnlyTasksHint'

export function resolveTasksAccessHintKey(
  isAuthenticated: boolean
): TasksAccessHintKey {
  if (!isAuthenticated) {
    return 'signInForTasksHint'
  }
  return 'fanOnlyTasksHint'
}
